<template>
    <div>
        <div :class="['row kcc-expand', {'kcc-expanded' : expanded}]">
            <div
                id="kcc-content-expansion-header"
                class="col-md-8 d-flex justify-content-start align-items-start flex-column"
                @click="() => toggleExpansionOnHeaderClick && toggleExpansion()"
            >
                <div class="kcc-expand-title">
                    <slot name="title" />
                </div>
                <div class="kcc-expand-subtitle">
                    <slot name="subtitle" />
                </div>
            </div>
            <div class="col-md-4 d-flex justify-content-end align-items-center">
                <slot name="actions" />
                <FloatingActionButton
                    data-cy="expandEvent"
                    class="kcc-expand-fab-button ml-2"
                    type="custom"
                    :icon="['far', 'expand-alt']"
                    @click="toggleExpansion"
                />
            </div>
        </div>
        <BCollapse
            v-model="expanded"
            class="kcc-expand-collapse"
            data-cy="expandCollapse"
        >
            <slot name="content" />
        </BCollapse>
    </div>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {
        faExpandAlt,
    } from '@fortawesome/pro-regular-svg-icons';

    library.add(
        faExpandAlt,
    );

    import FloatingActionButton from './FloatingActionButton.vue';

    /**
     * @group Sections
     * A component to utilize a Kit Car KCContentExpansion component.
     */
    export default {
        name: 'KCContentExpansion',
        components: {FloatingActionButton},
        props: {
            /**
             * Boolean value to expand by default
             */
            isExpanded: {
                type: Boolean,
                default: false
            },
            /**
             * Boolean value that allows content to be expanded when expansion header is clicked
             */
            toggleExpansionOnHeaderClick: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                expanded: false
            };
        },
        watch: {
            isExpanded(newValue) {
                this.expanded = newValue;
                this.$emit('toggle', this.expanded);
            }
        },
        created() {
            this.expanded = this.isExpanded;
        },
        methods: {
            toggleExpansion() {
                this.expanded = !this.expanded;
                this.$emit('toggle', this.expanded);
            }
        }
    };
</script>
